import axios from "axios";
import { getEnv } from "./environment";
const env = getEnv();

const axiosInstance = axios.create({
  baseURL: env.url,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
